import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../Spinner/Spinner";
import { rememberReturnTo } from "../../../utils/helpers/sessionHandoff";

export default function ProtectedRoute({
  isAllowed,
  isLoading,
  redirectPath = "/login",
  children,
}) {
  const { t } = useTranslation();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        <Spinner label={t("common.loading")} size="lg" />
      </div>
    );
  }

  if (!isAllowed) {
    // Hold the destination so signing in returns to it. Stored rather than
    // passed as router state because the SSO round-trip leaves the app
    // entirely — the provider brings back a fresh document with no history.
    rememberReturnTo(`${location.pathname}${location.search}`);
    return <Navigate to={redirectPath} replace />;
  }

  return children ?? <Outlet />;
}
